import React, { useEffect, useRef } from 'react';
import Footer from '../Footer';
import './Brief.css';
import UsePageMetadata from '../../hooks/UsePageMetadata';

const PODIO_FORM_ID = '2162904';
const PODIO_ORIGIN = 'https://podio.com';
const PODIO_FORM_URL = `${PODIO_ORIGIN}/webforms/27450238/${PODIO_FORM_ID}`;

const Brief = ({ white, guardarWhite, guardarWhiteCaso }) => {
  UsePageMetadata('Brief | INDIO Agencia Digital' ?? '');

  const iframeRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    guardarWhite(true);
    guardarWhiteCaso(true);
  }, [guardarWhite, guardarWhiteCaso]);

  // El script oficial de Podio usa document.write, que no funciona en React.
  // Acá se replica lo que hace: pinta el iframe y lo redimensiona con los
  // mensajes "<formId>:<alto>:<scrollToTop>" que envía el formulario.
  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin !== PODIO_ORIGIN || typeof e.data !== 'string') return;

      const [senderId, height, scrollToTop] = e.data.split(':');
      const iframe = iframeRef.current;
      if (senderId !== PODIO_FORM_ID || !parseInt(height, 10) || !iframe) return;

      iframe.style.height = `${parseInt(height, 10)}px`;
      if (scrollToTop === 'true') {
        window.scrollTo(0, iframe.getBoundingClientRect().top + window.pageYOffset);
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <div>
      <section id='brief' className='max-width'>
        <div className='brief_formulario'>
          <iframe
            ref={iframeRef}
            className='podio-webform-frame'
            title='Brief'
            src={`${PODIO_FORM_URL}?e=true#${encodeURIComponent(window.location.href)}`}
            height='5205'
            frameBorder='0'
            scrolling='yes'
          ></iframe>
        </div>
        <div className='clearfix'></div>
      </section>

      <Footer white={white} />
    </div>
  );
};

export default Brief;
